import { url } from '@/helpers/UrlHelpers';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class FetchAllSubscriptions {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * FetchAllSubscriptions constructor.
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
        this.apiService.enableAuth();
    }

    /**
     * Get all the user's subscriptions.
     *
     * @param {number} userId
     *
     * @returns {Promise}
     */
    handle(userId) {
        let apiUrl = url(ApiEndpoints['subscriptions'], [userId]);

        return this.apiService.get(apiUrl);
    }
}
